
import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { postAPI } from '../ApiService';

const showLoginToast = (message, icon = 'error') => {
    Swal.fire({
        toast: true,
        position: 'top-end',
        icon,
        text: message || 'Login failed. Please try again.',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
    });
};

const Login_page = () => {
    const [email, setEmail] = useState();
    const [password, setPassword] = useState();
    const [passwordType, setPasswordType] = useState(true);
    const [keepLoggedIn, setKeepLoggedIn] = useState(false);
    const [emailError, setemailError] = useState();
    const [passwordError, setPasswordError] = useState();
    const [error, setError] = useState();

    useEffect(() => {
        if(localStorage.getItem('token')){
            // navigate("/all-project");
            window.location.href = "/projects?status=active" ;
        }
    })
    
    const handleData = (e) => {
        let value = e.target.value;
        let name = e.target.name;
    
        switch (name) {
          case 'username':
            setEmail(value)
            setemailError();
            break;
          case 'password':
            setPassword(value);
            setPasswordError();
            break;
        
          default:
            break;
        }
      }

      const onUserLogin = async () => {
        setError();
        setemailError();
        setPasswordError();
        if (!email) {
            setemailError(" *Required");
            showLoginToast("Please enter username");
            return;
        }
        if (!password) {
            setPasswordError(" *Required");
            showLoginToast("Please enter password");
            return;
        }
        let data = {
            email : email,
            password : password,
            keepLoggedIn: keepLoggedIn ? 1 : 0
        }
        try {
            let res = await postAPI('/auth/login/', data)
            if(res?.status === 1){
                localStorage.setItem('token', res.payload.token);
                localStorage.setItem('userDetail', JSON.stringify(res.payload));
                localStorage.setItem('keepLoggedIn', keepLoggedIn ? '1' : '0');
                //navigate("/all-project");
                window.location.href = "/projects?status=active" ;
            }else{
                const message = res?.message || 'Invalid credentials';
                setError(message);
                showLoginToast(message);
            }
        } catch (err) {
            const message = err?.response?.data?.message || 'Login failed. Please try again.';
            setError(message);
            showLoginToast(message);
        }
    }
    
    useEffect(() => {
        document.title = "Sign In | Mindforce - Admin & Dashboard"
    }, []);
    return (
        <>
            <div
                className="auth-page-wrapper"
                style={{
                    position: "fixed",
                    inset: 0,
                    minHeight: "100dvh",
                    marginLeft: 0,
                    left: 0,
                    top: 0,
                    right: 0,
                    bottom: 0,
                    paddingLeft: 0,
                    width: "100%",
                    maxWidth: "100%",
                    overflowY: "auto",
                    backgroundImage: "linear-gradient(rgba(11,18,32,0.72), rgba(31,54,88,0.72)), url('/assets/images/auth-one-bg-1.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat"
                }}
            >
                <div className="auth-page-content d-flex align-items-center" style={{ minHeight: "100vh", position: "relative", zIndex: 2, padding: "2rem 0" }}>
                    <div className="container-fluid px-3 px-md-4 px-xl-5">
                        <div className="row align-items-center g-4 g-lg-5">
                            <div className="col-lg-6 d-none d-lg-block">
                                <div className="text-white pe-lg-4">
                                    <div className="badge bg-light text-dark px-3 py-2 mb-3" style={{ borderRadius: "999px", opacity: 0.95, fontSize: "12px" }}>
                                        Enterprise Survey Operations
                                    </div>
                                    <h1 className="fw-semibold mb-3" style={{ lineHeight: 1.2, fontSize: "56px" }}>Survey Management Tool</h1>
                                    <p className="mb-4 text-white-50" style={{ maxWidth: "560px", fontSize: "17px" }}>
                                        Manage projects, prescreening, supplier mappings, and client reporting from one secure platform.
                                    </p>
                                    <div className="d-flex gap-4 text-white-50" style={{ fontSize: "15px" }}>
                                        <div>
                                            <div className="fw-semibold text-white" style={{ fontSize: "16px" }}>Secure Access</div>
                                            <small>Role-based control</small>
                                        </div>
                                        <div>
                                            <div className="fw-semibold text-white" style={{ fontSize: "16px" }}>Operational Ready</div>
                                            <small>Built for research teams</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-10 col-lg-6 col-xl-5 mx-auto">
                                <div
                                    className="card border-0 shadow-lg"
                                    style={{
                                        borderRadius: "16px",
                                        backgroundColor: "rgba(255,255,255,0.96)"
                                    }}
                                >

                                    <div className="card-body p-4 p-md-5">
                                        <div className="text-center mt-2">
                                            <div className='mb-3'>
                                                <a href="/" className="d-inline-block auth-logo">
                                                    <img src="/assets/images/logo-big.png" alt="Mindforce logo" style={{ width: "100%", height: "64px", objectFit: "contain" }} />
                                                </a>
                                            </div>
                                            <h5 className="mb-1 fw-semibold text-dark" style={{ fontSize: "28px" }}>Sign in to your workspace</h5>
                                            <p className="text-muted mb-0" style={{ fontSize: "15px" }}>Use your organization credentials to continue</p>
                                        </div>
                                        <div className="p-2 mt-4">
                                            <p className='errorMessage text-center mb-2'>{error}</p>
                                                <div className="mb-3">
                                                    <label htmlFor="username" className="form-label fw-semibold" style={{ fontSize: "14px" }}>Username <span className='errorMessage'> {emailError}</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        style={{ height: "48px", borderRadius: "10px", fontSize: "15px" }}
                                                        id="username"
                                                        name="username"
                                                        placeholder="Enter username"
                                                        value={email}
                                                        onChange={(e)=>handleData(e)}
                                                    />
                                                </div>

                                                <div className="mb-3">
                                                    <label className="form-label fw-semibold" style={{ fontSize: "14px" }} htmlFor="password-input">Password <span className='errorMessage'> {passwordError}</span></label>
                                                    <div className="position-relative auth-pass-inputgroup mb-3">
                                                        <input
                                                            type={passwordType ? 'password':'text'}
                                                            className="form-control pe-5 password-input"
                                                            style={{ height: "48px", borderRadius: "10px", fontSize: "15px" }}
                                                            placeholder="Enter password"
                                                            name="password"
                                                            id="password-input"
                                                            value={password}
                                                            onChange={(e)=>handleData(e)}
                                                        />
                                                        <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon" type="button" id="password-addon" onClick={() => setPasswordType(!passwordType)}><i className="ri-eye-fill align-middle"></i></button>
                                                    </div>
                                                </div>

                                                <div className="form-check mb-2">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="auth-remember-check"
                                                        checked={keepLoggedIn}
                                                        onChange={(e) => setKeepLoggedIn(e.target.checked)}
                                                    />
                                                    <label className="form-check-label" style={{ fontSize: "14px" }} htmlFor="auth-remember-check">Remember me</label>
                                                </div>

                                                <div className="mt-4">
                                                    <button
                                                        className="btn w-100 fw-semibold"
                                                        style={{ height: "50px", borderRadius: "10px", backgroundColor: "#405189", borderColor: "#405189", color: "#fff", fontSize: "16px" }}
                                                        onClick={()=>onUserLogin()}
                                                    >
                                                        Sign In
                                                    </button>

                                                </div>
                                        </div>
                                    </div>
                                    {/* <!-- end card body --> */}
                                </div>
                                {/* <!-- end card --> */}



                            </div>
                        </div>
                        {/* <!-- end row --> */}
                    </div>
                    {/* <!-- end container --> */}
                </div>

                {/* <!-- footer --> */}
                <footer className="footer" style={{ position: "relative", zIndex: 2 }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="text-center">
                                    <p className="mb-0 text-muted">
                                        &copy; {new Date().getFullYear()} - Mindforce Research Pvt. Ltd. All rights reserved.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
                {/* <!-- end Footer --> */}
            </div>
        </>);
};

export default Login_page;
